import {
  Bookmark,
  Calendar,
  Check,
  Folder,
  Heart,
  House,
  Map,
  MessagesSquare,
  Newspaper,
  Compass,
  Tag,
  type LucideIcon,
} from "lucide-react";
import { CHAT, COLLECTIONS, DONE, EVENTS, EXPLORE, FAVORITES, HOME, MAP, ROUNDUPS, STASHES, TAGS } from "@/routes";
import type { TabId } from "@/routes/routeObjects";
import type { PlaceablePage } from "./homeLayout";
import { storedStartPage } from "./useHomeLayout";

export interface PageInfo {
  title: string;
  icon: LucideIcon;
  to: string;
  /** The retained tab it opens. Roundups has none: its route is a pushed page. */
  tab?: TabId;
}

/**
 * Titles and symbols follow the native app (`PlaceablePage` in AppNavigation.swift).
 * A page the web doesn't have yet is null: layouts keep it (they sync with the
 * native app later) and the web skips it.
 */
export const PAGE_INFO: Record<PlaceablePage, PageInfo | null> = {
  faves: { title: "Favorites", icon: Heart, to: FAVORITES(), tab: "favorites" },
  done: { title: "Done", icon: Check, to: DONE(), tab: "done" },
  "all-stashes": { title: "All stashes", icon: Bookmark, to: STASHES(), tab: "stashes" },
  tags: { title: "Tags", icon: Tag, to: TAGS(), tab: "tags" },
  collections: { title: "Collections", icon: Folder, to: COLLECTIONS(), tab: "collections" },
  roundups: { title: "Roundups", icon: Newspaper, to: ROUNDUPS(), tab: "roundups" },
  calendar: { title: "Events", icon: Calendar, to: EVENTS(), tab: "events" },
  map: { title: "Map", icon: Map, to: MAP(), tab: "map" },
  discover: { title: "Explore", icon: Compass, to: EXPLORE(), tab: "explore" },
  chat: { title: "Chat", icon: MessagesSquare, to: CHAT(), tab: "chat" },
};

/**
 * Where the app opens (Settings › Home, menu and start), read once at entry as
 * natively; links still open what they name. Home when unset or not on the web.
 */
export const startPagePath = (): string => {
  const page = storedStartPage();
  return (page && PAGE_INFO[page]?.to) || HOME();
};

/** Home: in the menu like any page (as `stashes`), never a shortcut. */
export const HOME_INFO: PageInfo = { title: "Home", icon: House, to: HOME(), tab: "home" };
